import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import 'owl.carousel';
declare var $: any; // Esto es necesario para evitar problemas con TypeScript

@Component({
  selector: 'app-clients-says',
  templateUrl: './clients-says.html',
  styleUrls: ['./clients-says.scss']
})
export class ClientsSaysComponent implements AfterViewInit, OnDestroy {
  private owlInstance: any;

  ngAfterViewInit(): void {
    this.initOwlCarousel();
  }

  initOwlCarousel() {
    setTimeout(() => {
      this.owlInstance = $('.client-wrap').owlCarousel({
        loop: true,
        nav: false,
        autoplay: true,
        autoplayHoverPause: true,
        mouseDrag: true,
        margin: 30,
        center: false,
        dots: true,
        smartSpeed: 1500,
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 2
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          },
          1200: {
            items: 3
          }
        }
      });
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.owlInstance) {
      this.owlInstance.trigger('destroy.owl.carousel');
    }
  }
}
